/**
 * Лёгкий срез каталога для главной страницы.
 *
 * Зачем отдельный файл: главной нужны 8 названий и общее число виджетов,
 * а импорт всего каталога тянул в её чанк ~80 КБ текста лендингов.
 * Здесь только то, что реально рендерится.
 *
 * Синхронность с каталогом проверяется тестом
 * src/data/widgets/__tests__/featured.test.js — если добавили или
 * переименовали виджет, тест упадёт.
 */

import { isReleased } from './release';

/**
 * Сколько всего виджетов в каталоге, включая ещё не открытые.
 * Синхронность с каталогом проверяется тестом.
 */
export const TOTAL_WIDGETS = 36;

/**
 * Сколько типов виджетов в самом расширении (4.0.0: 35 классов в реестре,
 * data/screenshots/report-4-new-widgets.md §1). Меньше TOTAL_WIDGETS на
 * один: лендинг /widgets/wallpaper описывает выбор фона, а не виджет.
 * Это число показывается людям, поэтому держим его отдельно.
 */
export const WIDGET_TYPES = 35;

/**
 * Виджеты для главной, из которых убраны ещё не открытые: ссылка на закрытую
 * страницу вела бы на 404, а таких ссылок на главной быть не должно.
 *
 * @param {number|Date} [now]
 * @returns {Array<{slug: string, name: string}>}
 */

/** Виджеты, вынесенные ссылками на главную. */
export const FEATURED_WIDGETS = [
	{ slug: 'countdown', name: 'Countdown', category: 'Time' },
	{ slug: 'todo-list', name: 'To-Do List', category: 'Productivity' },
	{ slug: 'habit-tracker', name: 'Habit Tracker', category: 'Productivity' },
	{ slug: 'clock', name: 'Digital Clock', category: 'Time' },
	{ slug: 'notes', name: 'Notes', category: 'Productivity' },
	{ slug: 'weather', name: 'Weather', category: 'Design' },
	{ slug: 'wallpaper', name: 'Wallpaper & Background', category: 'Design' },
	{ slug: 'image', name: 'Image & GIF', category: 'Design' },
];

export function getFeaturedWidgets(now) {
	return FEATURED_WIDGETS.filter(widget => isReleased(widget.slug, now));
}
